//
// Get media types (source : laravel config/billing.php
const billingParameters = window.config.billing

export default Object.freeze(billingParameters)
